import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectState } from '../../../../selectors';
import { BlackText } from '../../../styled/components/thank-you';

const TileWrapper = styled.div`
  border: 1px solid var(--color-accent-border);
  border-radius: 3px;
  width: 325px;
  min-height: 225px;
  padding: 30px;
  margin: 30px;
  h1 {
    color: var(--color-text-primary);
    line-height: 29px;
    font-size: 23px;
    padding-bottom: 20px;
  }

  p {
    color: var(--color-text-primary);
    line-height: 24px;
    padding-bottom: 25px;
  }

  @media (min-width: 1041px) {
    min-width: 305px;
  }
  @media (max-width: 1260px) {
    min-width: 330px;
  }
  @media (max-width: 1040px) {
    min-width: 355px;
  }
  @media (max-width: 765px) {
    min-width: 405px;
  }
  @media (max-width: 599px) {
    min-width: 0px;
  }
`;

const FreeTrialThankYou = () => {
  const {
    offer: {
      thankYouContent: { customHeadingText, topTextContent },
    },
    sharedSignup: {
      signupForm: { email },
    },
  } = useSelector(selectState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SRow>
      <SCol span='12'>
        <div className='flex justify-content-center'>
          <h1 className='text-center pad-bottom-md' data-ref='buy.free-trial.thank-you.custom-heading-text'>
            {customHeadingText}
          </h1>
        </div>

        {topTextContent && topTextContent.length > 0 && (
          <div
            className='flex flex-dir-col align-items-center text-center'
            data-ref='buy.free-trial.thank-you.top-text-content'
          >
            {topTextContent.map((text) => (
              <h2 key={text} className='pad-bottom-md text-center'>
                {text}
              </h2>
            ))}
          </div>
        )}

        <BlackText>
          <div
            className='flex flex-dir-col align-items-center pad-left-sm pad-right-sm'
            data-ref='buy.free-trial.thank-you.resource-content'
          >
            <SRow className='justify-content-center'>
              <TileWrapper className='pad-right-md'>
                <h1>{t('client.headings.get-started-with-avalara')}</h1>
                <p>{t('client.general.order-confirmation-will-be-sent-to-email-followed-by-welcome', { email })}</p>
              </TileWrapper>
            </SRow>
          </div>
        </BlackText>
      </SCol>
    </SRow>
  );
};

export default FreeTrialThankYou;
